module.exports = __webpack_public_path__ + "static/media/road-america-2025@2x.94d8bedb.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/road-america-2025@2x.png
// module id = 1149
// module chunks = 0